import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    errorStyle: {
        height: "100px",
        padding: "2em",
        backgroundColor: "#e9ecef",
        margin: "1em",
        color: "red"
    },
    loadingStyle: {
        height: "100px",
        padding: "2em",
    },
    mapStyle: {
        // display: "block",
        // width: "100%",
        // border: "2px solid black",
        // borderRadius: "5px",
        // padding: "1px",
        // margin: "10px 0px"
    },
    lastUpdateStyle: {
        // position: "absolute",
        // top: "8px",
        // left: "8px",
        // zIndex: 1,
        // padding: "8px",
        // borderRadius: "8px",
        // background: rgb(255, 255, 255),
        // userSelect: "none"
    }
});


export default styles;
